export default "__VITE_ASSET__BD6GScjU__"